module.exports = __webpack_public_path__ + "img/pay-info-checked.33bf555d.svg";